// extracted by mini-css-extract-plugin
module.exports = {"infoDiv":"EditLicense_infoDiv__1zUKr","title":"EditLicense_title__AHT6r"};